import script from "./SettingsNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsNotifications.vue?vue&type=style&index=0&id=d301e464&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d301e464"]])

export default __exports__